/* global require */
import Vue from "vue";

import { trans } from "common/translate";

import { clickOutside } from "common/click-outside.js";

import "./facet.js";

export default Vue.component("facet-group", {
  props: ["group", "isManuscript", "tabindex"],
  data() {
    return { trans, overflowOpen: false };
  },

  computed: {
    hasOverflow() {
      return this.group.groups.more.length > 0;
    }
  },

  directives: {
    clickOutside
  },

  methods: {
    collapseOverflow() {
      this.overflowOpen = false;
    }
  },

  template: require("./templates/facet-group.html"),
});



// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/archive/facet-group.js